import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import {fileToBase64Object} from '@coolcolduk/util';
import {
  ContactCategory,
  ContactMessage,
  ContactMessageInput,
  MutationCreateContactMessageArgs,
} from '../__generated__/resolvers-types';

export const CREATE_CONTACT_MESSAGE_MUTATION = gql`
  mutation Mutation($contactMessage: ContactMessageInput!) {
    createContactMessage(contactMessage: $contactMessage) {
      id
      name
      email
      category
      message
    }
  }
`;

/**
 * Hook for creating contact messages with file attachments
 * @returns
 */
export default function useCreateContactMessage() {
  const [createContactMessage, {data, loading, error}] = useMutation<ContactMessage, MutationCreateContactMessageArgs>(
    CREATE_CONTACT_MESSAGE_MUTATION,
  );

  return {
    createContactMessage: async (
      name: string,
      email: string,
      category: ContactCategory,
      message: string,
      attachments: File[],
    ) => {
      const contactMessage: ContactMessageInput = {
        name,
        email,
        category,
        message,
        attachments: await Promise.all(attachments.map((a) => fileToBase64Object(a))),
      };
      return createContactMessage({
        variables: {contactMessage},
      });
    },
    data,
    loading,
    error,
  };
}
